import { useEffect, useRef } from 'react';
import { WbSphereView } from '@workbench/react';

// The API returns the six cube faces in an order the sphere view does not expect.
const FACE_ORDER = [3, 1, 4, 5, 0, 2];

function Interior360View({ images }) {
	const viewRef = useRef();

	useEffect(() => {
		if (!viewRef.current) return;
		viewRef.current.textureUrls = FACE_ORDER.map((index) => images[index]);
		viewRef.current.fieldOfView = 100;
	}, [images]);

	return <WbSphereView ref={viewRef} />;
}

export default Interior360View;
